import React from 'react';
import propTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { useMap, useDeviceType, useConfig } from '../../../hooks';

import GeolocationButton from './../../GeolocationButton';
import GoogleMapsNotice from '../../GoogleMapsNotice';
import Button from '../../Button';

function MapOverlay({ initialDealer, location, userLocation, onUserLocationChange }) {
  const { config } = useConfig();
  const { isMobile } = useDeviceType();
  const { googleMapsConsent, mapEnabled, setMapEnabled } = useMap();
  const { t } = useTranslation('dealers');

  function handleMapActivation() {
    setMapEnabled(true);
  }

  function handleLocate(result) {
    setMapEnabled(true);
    onUserLocationChange(result);
  }

  const title = config.mapTitle && !isMobile && (
    <h1 className="map-title-header">{config.mapTitle}</h1>
  );

  if (!googleMapsConsent) {
    return (
      <div className="map-overlay">
        {title}
        <GoogleMapsNotice enableMap={!!location} />
      </div>
    );
  }
  else if (!mapEnabled) {
    if (!location) {
      return (
        <div className="map-overlay">
          <p>{t('Search help text')}</p>
          <GeolocationButton onLocate={handleLocate} />
        </div>
      );
    }

    return (
      <div className="map-overlay">
        {title}
        <Button label={t('Show map')} icon={'Oval-White'} onClick={handleMapActivation} />
      </div>
    );
  }
  return null;
}

MapOverlay.propTypes = {
  initialDealer: propTypes.object,
  location: propTypes.object,
  userLocation: propTypes.object,
  onUserLocationChange: propTypes.func,
};

export default MapOverlay;
